export default "__VITE_ASSET__Bn15Gj6w__"